/*
  heymindful: Automatische Produktempfehlungen (Shopify Recommendations API, intent=related).
  Lädt sections/api-empfehlungen.liquid und setzt die Produktkarten in <hm-empfehlungen> ein.
  Im Warenkorb blendet das Theme das Upsell-Widget aus, solange es leer ist – nach dem Laden
  wird es hier wieder eingeblendet.
*/
(() => {
  if (customElements.get('hm-empfehlungen')) return;

  class HmEmpfehlungen extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;

      fetch(this.dataset.url)
        .then((response) => (response.ok ? response.text() : ''))
        .then((html) => this.render(html))
        .catch(() => this.render(''));
    }

    render(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const max = parseInt(this.dataset.max, 10) || 4;
      const items = [...doc.querySelectorAll('[data-hm-reco-item]')].slice(0, max);

      if (!items.length) return;

      // Gleiches Produkt kann auf der Produktseite und im Warenkorb gleichzeitig stehen: IDs eindeutig machen
      const suffix = `-${this.dataset.context || 'reco'}`;
      items.forEach((item) => {
        item.querySelectorAll('[id]').forEach((el) => (el.id += suffix));
        item.querySelectorAll('[form]').forEach((el) => el.setAttribute('form', el.getAttribute('form') + suffix));
      });

      this.querySelector('[data-hm-reco-track]').replaceChildren(...items.map((item) => document.adoptNode(item)));
      this.hidden = false;

      const wrapper = this.closest('[data-hm-reco-wrapper]');
      if (wrapper) wrapper.hidden = false;

      this.showCartWidget();
    }

    showCartWidget() {
      const widget = this.closest('[data-upsell-widget]');
      if (!widget) return;

      widget.classList.remove('is-hidden');

      if (widget.hasAttribute('data-upsell-auto-open') && !widget.hasAttribute('open')) {
        widget.setAttribute('open', true);
        const body = widget.querySelector('[data-collapsible-body]');
        if (body) body.style.height = 'auto';
      }
    }
  }

  customElements.define('hm-empfehlungen', HmEmpfehlungen);
})();
